export default __webpack_public_path__ + "static/media/phone.0c90177d.svg";